"use client";

import React from "react";
import { ChevronDown } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function OurVisualLegacy() {
  const {
    ref: textRef,
    isVisible: isTextVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="143034" id="the-sensory-experience" className="dark bg-background text-foreground relative min-h-[100svh] flex flex-col items-center justify-center overflow-hidden">
      {}
      <div className="absolute inset-0 z-0">
        <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1603357/img/beauty_sensory_mood.png)] bg-cover bg-center bg-no-repeat opacity-30 mix-blend-luminosity scale-105 animate-pulse" style={{
        animationDuration: '20s'
      }} />
        <div className="absolute inset-0 bg-gradient-to-b from-background/40 via-background/70 to-background" />
        <div className="absolute inset-0 bg-radial from-transparent to-background/90" />
      </div>

      {}
      <div ref={textRef} className={`relative z-10 container mx-auto px-4 flex flex-col items-center text-center transition-all duration-1000 ease-out ${isTextVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
        <span className="text-chart-3 font-mono tracking-widest uppercase text-sm md:text-base mb-6 block">
          Natalia&apos;s Beauty — Brooke
        </span>
        <h1 className="text-5xl md:text-7xl lg:text-8xl font-serif font-light tracking-wider mb-6 text-balance drop-shadow-2xl">
          The Sensory Experience
        </h1>
        <p className="text-lg md:text-xl text-muted-foreground font-sans max-w-2xl mx-auto text-balance">A calm and welcoming space where expert care meets total relaxation. At Natalia’s Beauty, we offer personalised beauty and aesthetic treatments designed to enhance your natural glow and leave you feeling your very best.</p>
      </div>

      {}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2 opacity-60 hover:opacity-100 transition-opacity cursor-pointer">
        <span className="text-xs font-mono tracking-widest uppercase text-chart-3">Explore</span>
        <ChevronDown className="size-6 text-chart-3 animate-bounce" />
      </div>
    </section>;
}